<div class="sb-field-error-container">
  <ng-content></ng-content>
</div>
